import * as React from 'react';
import FontAwesomeIcon from '../../FontAwesomeIcon';

function SolutionCustomIcon({ name }) {
	return <FontAwesomeIcon name={`fas fa-${name}`} />;
}

export default SolutionCustomIcon;
